class Station {
  constructor(title, latitude, longitude, code, zoneId, geographicalTypeId) {
    this.title = title;
    this.latitude = latitude;
    this.longitude = longitude;
    this.code = code;
    this.zoneId = zoneId;
    this.geographicalTypeId = geographicalTypeId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      stationId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      provinceTitle: '',
      stationManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'کد پایگاه', value: 'code', align: 'center' },
        { text: 'شهرستان', value: 'city', align: 'center' },
        { text: 'ناحیه', value: 'zone', align: 'center' },
        { text: 'نوع پایگاه', value: 'geographicalTypeTitle', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchZoneId: null,
      searchCityId: null,
      searchText: '',
      searchCode: '',
      stationphoneNumbers: [],
      cityId: null,
      //fance
      stationFanceModal: false,
      drawLayer: null,
      addFanceCordsLatLng: [],
      stationHasFance: false,
      drawedFanceInfo: null,
      polyganData: {},
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن پایگاه';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش پایگاه';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getStationFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.station = new Station('', null, null, null, '', null);
      this.position = null;
      this.cityId = null;
      this.allZonesForOther = [];
      this.resetMap();
      this.stationphoneNumbers = [];
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addStationFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش پایگاه';
        this.$refs.confirm.text = 'از ویرایش پایگاه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف پایگاه';
        this.$refs.confirm.text = 'از حذف پایگاه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'removeFance') {
        this.$refs.confirm.title = 'حذف فنس پایگاه';
        this.$refs.confirm.text = 'از حذف فنس پایگاه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addStationFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editStationFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteStationFunction();
      } else if (this.confimType == 'removeFance') {
        this.disabelConfirm = true;
        this.removeStationFanceFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'removeFance') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.stationId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    showRemoveFanceConfirmFunction: function () {
      // this.stationId = id;
      this.confimType = 'removeFance';
      this.showConfirmDialogFunction();
    },
    setProvinceForGetCityGeoLocation: function () {
      if (this.allProvincesForOther.length == 1) {
        this.provinceTitle = this.allProvincesForOther[0].title;
      }
    },
    getCityGeoLocation: function () {
      if (this.cityId) {
        this.getListOfZonesForOther(this.cityId);
        if (this.provinceTitle && this.cityId) {
          let cityName = '';
          for (let i = 0; i < this.allCitysForOther.length; i++) {
            if (this.cityId == this.allCitysForOther[i].id)
              cityName = this.allCitysForOther[i].title;
          }
          this.searchForLocation(cityName, this.provinceTitle);
        }
      }
    },
    goToCity: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data[0].lat, data[0].lon], 12);
    },
    resetMap: function () {
      this.$refs.modalmap.mapObject.flyTo([30.2839, 57.0834], 10);
    },
    //search
    searchCityChange: function () {
      if (this.searchCityId) {
        this.getListOfZonesForOther(this.searchCityId);
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfStationsWithPagination();
    },
    removeFilters: function () {
      this.searchZoneId = null;
      this.searchCityId = null;
      this.allZonesForOther = [];
      this.searchText = '';
      this.searchCode = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfStationsWithPagination();
    },
    cancelSearch: function () {
      this.searchZoneId = null;
      this.searchCityId = null;
      this.allZonesForOther = [];
      this.searchText = '';
      this.searchCode = '';
      this.searchModal = false;
    },
    //fance
    closeStationFenceModal: function () {
      this.stationFanceModal = false;
      this.stationId = null;
      this.addFanceCordsLatLng = [];
      this.polyganData = {};
      const map = this.$refs.fancemap.mapObject;
      for (let i in map._layers) {
        if (map._layers[i]._path != undefined) {
          try {
            map.removeLayer(map._layers[i]);
          } catch (e) {
            this.snackText = e;
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        }
      }
      this.stationHasFance = false;
    },
    showFanceModal: function (id) {
      this.stationId = id;
      this.getAllStationFancesFunction(id);
    },
    enableFenceModal: function () {
      this.stationFanceModal = true;
      this.fanceMapInvalidate();
      if (this.stationHasFance == false) {
        this.$nextTick(() => {
          const map = this.$refs.fancemap.mapObject;
          map.pm.setLang('fa');
          map.on('pm:create', ({ layer }) => {
            this.drawFanse(layer);
          });
          map.pm.addControls({
            position: 'bottomleft',
            drawCircle: false,
            drawRectangle: false,
            drawPolyline: false,
            editMode: false,
            cutPolygon: false,
            drawCircleMarker: false,
            drawMarker: false,
            optionsControls: false,
            removalMode: false,
            dragMode: false,
            drawText: false,
            rotateMode: false,
            drawPolygon: true,
          });
        });
      } else {
        this.polyganData = {
          latlngs: [],
        };
        for (let i = 0; i < this.drawedFanceInfo.length; i++) {
          let data = [];
          data.push(this.drawedFanceInfo[i].latitude);
          data.push(this.drawedFanceInfo[i].longitude);
          this.polyganData.latlngs.push(data);
        }
        this.$nextTick(() => {
          const map = this.$refs.fancemap.mapObject;
          map.pm.setLang('fa');
          map.on('pm:remove', ({ layer }) => {
            this.removeFance(layer);
          });
          map.on('pm:globaleditmodetoggled', (e) => {
            e.map.pm.getGeomanLayers(true).on('pm:update', ({ layer }) => {
              this.editFance(layer);
            });
          });
          map.pm.addControls({
            position: 'bottomleft',
            drawCircle: false,
            drawRectangle: false,
            drawPolyline: false,
            editMode: true,
            cutPolygon: false,
            drawCircleMarker: false,
            drawMarker: false,
            optionsControls: false,
            removalMode: true,
            dragMode: false,
            drawText: false,
            rotateMode: false,
            drawPolygon: false,
          });
        });
      }
    },
    drawFanse: function (layer) {
      this.drawLayer = layer;
      var coords = layer.getLatLngs();
      this.addFanceCordsLatLng = coords;
      this.$nextTick(() => {
        const map = this.$refs.fancemap.mapObject;
        map.pm.setLang('fa');
        map.on('pm:remove', ({ layer }) => {
          this.removeFance(layer);
        });
        map.on('pm:globaleditmodetoggled', (e) => {
          e.map.pm.getGeomanLayers(true).on('pm:update', ({ layer }) => {
            this.editFance(layer);
          });
        });
        map.pm.addControls({
          position: 'bottomleft',
          drawCircle: false,
          drawRectangle: false,
          drawPolyline: false,
          editMode: true,
          cutPolygon: false,
          drawCircleMarker: false,
          drawMarker: false,
          optionsControls: false,
          removalMode: true,
          dragMode: false,
          drawText: false,
          rotateMode: false,
          drawPolygon: false,
        });
      });
    },
    removeFance: function (layer) {
      this.drawLayer = layer;
      this.addFanceCordsLatLng = [];
      this.$nextTick(() => {
        const map = this.$refs.fancemap.mapObject;
        map.pm.setLang('fa');
        map.on('pm:create', ({ layer }) => {
          this.drawFanse(layer);
        });
        map.pm.addControls({
          position: 'bottomleft',
          drawCircle: false,
          drawRectangle: false,
          drawPolyline: false,
          editMode: false,
          cutPolygon: false,
          drawCircleMarker: false,
          drawMarker: false,
          optionsControls: false,
          removalMode: false,
          dragMode: false,
          drawText: false,
          rotateMode: false,
          drawPolygon: true,
        });
      });
    },
    editFance: function (layer) {
      this.drawLayer = layer;
      var coords = layer.getLatLngs();
      this.addFanceCordsLatLng = coords;
      this.$nextTick(() => {
        const map = this.$refs.fancemap.mapObject;
        map.pm.setLang('fa');
        map.on('pm:remove', ({ layer }) => {
          this.removeFance(layer);
        });
        map.on('pm:globaleditmodetoggled', (e) => {
          e.map.pm.getGeomanLayers(true).on('pm:update', ({ layer }) => {
            this.editFance(layer);
          });
        });
        map.pm.addControls({
          position: 'bottomleft',
          drawCircle: false,
          drawRectangle: false,
          drawPolyline: false,
          editMode: true,
          cutPolygon: false,
          drawCircleMarker: false,
          drawMarker: false,
          optionsControls: false,
          removalMode: true,
          dragMode: false,
          drawText: false,
          rotateMode: false,
          drawPolygon: false,
        });
      });
    },
    goToCoverage: function (stationId) {
      this.$router.push({
        name: 'stationCoverageZone',
        params: { id: stationId },
      });
    },
  },
};
